import classNames from "classnames";
import styles from "./AgreePersonalInfo.module.scss";
export default function AgreePesonalInfo({ isDarkMode, job }) {
  return (
    <section className={styles.container}>
      <div
        className={classNames(styles.contentsContainer, {
          "body-kr-M": true,
        })}
      >
        {job?.lo === "en" ? (
          <>
            <p>
              MondayOFF Co Ltd. (“MondayOFF”) collects and uses applicants’
              personal information as follows by the Act on Personal Information
              Protection Act. MondayOFF values the protection of personal
              information and will describe collected personal information in
              detail as well as use all information contained within the scope
              of the following purposes:
            </p>
            <div>
              <p>1. Purpose of Collection and Use of Personal Information</p>
              <p>1{")"} Management of job applicants </p>
              <p>
                2{")"} Identification based on job application and application
                history
              </p>
              <p>
                3{")"} Information we need to provide you with about the
                recruitment process and job offers
              </p>
              <p>
                4{")"} Complying with any applicable legal obligations or
                reporting obligations as well as establishing, exercising, or
                defending against any legal claims
              </p>
            </div>
            <div>
              <p>2.Collected Personal Information</p>
              <p>
                Contact information, such as Name, phone number, and email
                address Resume information, such as work experience, educational
                background, professional certifications, and similar
              </p>
            </div>

            <div>
              <p>3. Retention and Use Period of Personal Information</p>
              <p>
                Job application information will be stored for two years after
                applying for a job. Personal Information may be deleted promptly
                on request to MondayOFF.
              </p>
            </div>
            <div>
              <p>4. Refusal to consent</p>
              <p>
                Applicants have the right to refuse to consent to the collection
                and use of personal information as mentioned above. Please be
                aware that there may be disadvantages such as restrictions on
                recruitment screening.
              </p>
            </div>
            <div>
              <p>Personal Information Management Inquiry</p>
              <p>contact@mondayoff.me</p>
            </div>
          </>
        ) : (
          <>
            <p>
              먼데이오프 주식회사(이하 먼데이오프)는 지원자 여러분의 개인정보를
              수집하고 이용합니다. 먼데이오프는 지원자의 개인정보보호를 중요하게
              여기며 지원자의 개인정보가 어떤 용도와 방식으로 이용되고 있는지,
              개인정보보호를 위해 어떠한 조치가 취해지고 있는지 아래와 같이
              알려드립니다.
            </p>
            <div>
              <p>1. 수집 · 이용 항목 </p>
              <p>이름, 전화번호, 이메일주소, 이력서(경력사항 및 자기소개)</p>
            </div>
            <div>
              <p>2. 수집 · 이용 목적 </p>
              <p>수집한 개인정보는 아래와 같은 목적으로 이용됩니다.</p>
              <p>1{")"} 입사 지원자 관리 </p>
              <p>2{")"} 입사 지원에 따른 본인 확인, 지원 이력 확인</p>
              <p>3{")"} 채용전형의 진행, 채용결과 등 채용관련 정보 안내</p>
              <p>4{")"} 채용관련 민원처리 서비스 제공</p>
            </div>
            <div>
              <p>3. 개인정보의 보유 및 이용 기간</p>
              <p>
                입사 지원 정보: 입사 지원 후부터 2년 다만, 입사지원자가
                개인정보의 삭제를 원하는 경우 지체 없이 해당 정보를 삭제합니다.
              </p>
            </div>
            <div>
              <p>4. 동의를 거부할 권리 및 동의 거부에 따른 불이익 </p>
              <p>
                지원자는 개인정보의 수집, 이용 등과 관련한 위 사항에 대하여
                원하지 않는 경우 동의를 거부할 수 있습니다.다만, 수집하는
                개인정보의 항목에서 필수정보에 대한 수집 및 이용에 대하여
                동의하지 않는 경우는 채용전형에 제한이 있을 수 있습니다.
              </p>
            </div>
            <div>
              <p>개인정보 관리 문의</p>
              <p>contact@mondayoff.me</p>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
